import React, {useEffect, useState} from 'react';
import {Button} from "react-bootstrap";
import {useNavigate, useParams} from "react-router-dom";
import BackendService from "../BackendService/BackendService";
import Utils from '../BackendService/Utils';
import PopUp from "../PopUp/PopUp";

const ImageUploaderComponent = () => {
    const { categoryId, encodedReturnUrl } = useParams();
    let [file, setFile] : [any, any] = useState('');
    let [isLoading, setIsLoading] : [boolean, any] = useState(true);
    let [isSending, setIsSending] : [boolean, any] = useState(false);
    let [showPopUp, setShowPopUp]: [boolean, any] = useState(false);
    let [returnUrl, setReturnUrl]: [string, any] = useState("");
    let navigate = useNavigate();

    const uploadProduct = async () => {
        setIsSending(true)
        BackendService.uploadImage(Utils.determinateDatabaseCategoryId(categoryId), true, file).then((res) => {
            if(res.data == "OK"){
                setShowPopUp(true)
            }
            else{
                console.log(res.data)
                setIsSending(false)
            }
        }).catch((err) => {
            setIsSending(false)
            console.log(err)
        })
    }

    useEffect(() => {
        if(!Utils.UserIsLogged()){
            navigate("/401")
        }
        else if(categoryId == undefined || Utils.determinateDatabaseCategoryId(categoryId) == -1){
            navigate("/404")
        }
        else {
            setIsLoading(false);
        }
        if(encodedReturnUrl == undefined)
            setReturnUrl("/")
        else
            setReturnUrl(atob(encodedReturnUrl))
    }, [])

    if(isLoading){
        return(
            <div/>
        )
    }
    return (
        <div>
            <div className={"row justify-content-center mt-2"}>
                <div className={"col-6"}>
                    <h2>Pridanie obrázku</h2>
                    <form className={"form-inline mt-3"}>
                        <div className={"form-group"} >
                            <label style={{display: 'flex', justifyContent:'start'}}>Zvolťe obrázok:</label>
                            <input required={true} type={"file"} accept={"image/*"} className={"form-control"} onChange={(e) => setFile(e.target.files![0])}></input>
                        </div>
                        <div className={"mt-4"}>
                            <Button variant={"outline-danger"} onClick={() => navigate(returnUrl)}>Zahodiť</Button>
                            <Button variant={"success"} onClick={uploadProduct} disabled={isSending} style={{marginLeft: "10px"}}>{isSending ? "Ukladám" : "Uložiť"}</Button>
                        </div>
                    </form>
                </div>
            </div>
            <PopUp TitleText={"Obrázok pridaný"} BodyText={"Obrázok bol úspešne pridaný."} show={showPopUp} onHide={() => navigate(returnUrl)}></PopUp>
        </div>
    );
}

export default ImageUploaderComponent;